var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"momou"}},[(!_vm.installed)?_c('Install'):_vm._e(),(_vm.installed)?_c('Public'):_vm._e(),_c('Private'),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }